import React from "react"
import types from "prop-types"
import { useSelector } from "react-redux"
import { subscribedToAddOnFeature } from "reduxSlices/addOnFeatureSubscriptionsSlice"
import { currentUserId as getCurrentUserId, currentUserIsInAdminRole as getCurrentUserIsInAdminRole } from "reduxSlices/sessionSlice"
import { REPORT_SFTP_FEATURE_NAME } from "utils/addOnFeatureHelpers"
import { TASK_REPORT_TYPE } from "utils/reportHelpers"
import {
  editScheduledTaskReportExportPath,
  newScheduledTaskReportExportPath,
  newTaskReportExportPath,
} from "utils/routeHelpers"
import ItemRow from "shared/ItemRow"
import SvgSpriteIcon from "shared/SvgSpriteIcon"
import Tooltip, { TOP_CENTER } from "components/shared/Tooltip"
import NewReportExportLink from "./ReportElements/NewReportExportLink"
import ExpandedRowContent from "./ExpandedRowContent"
import TaskReportMenu from "./TaskReportMenu"

const TaskReportRow = ({ report }) => {
  const currentUserId = useSelector(getCurrentUserId)
  const currentUserIsInAdminRole = useSelector(getCurrentUserIsInAdminRole)
  const subscribedToSFTP = useSelector(subscribedToAddOnFeature(REPORT_SFTP_FEATURE_NAME))

  const {
    editable, deletable, shared, creatorId, creatorFullName, scheduledReportExport,
  } = report

  const createdByCurrentUser = currentUserId === creatorId

  return (
    <ItemRow
      collapsable={subscribedToSFTP && currentUserIsInAdminRole}
      itemRowBody={(
        <ExpandedRowContent
          report={report}
          reportType={TASK_REPORT_TYPE}
          newScheduledReportExportPath={newScheduledTaskReportExportPath}
          editScheduledReportExportPath={editScheduledTaskReportExportPath}
        />
      )}
      itemRowHeaderContent={(
        <>
          <div className="grow">
            {report.name}
          </div>
          <div className="flex items-center gap-2 shrink-0">
            {
              shared && !createdByCurrentUser && (
                <div className="text-sm text-dark">shared by {creatorFullName}</div>
              )
            }
            {
              scheduledReportExport && scheduledReportExport.scheduledReportExportSchedule.active
              && (
                <Tooltip
                  className="overflow-y-auto"
                  maxHeight="max-h-60"
                  position={TOP_CENTER}
                  text="SFTP Uploads Active"
                >
                  <SvgSpriteIcon iconName="rotate" />
                </Tooltip>
              )
            }
            <NewReportExportLink location={newTaskReportExportPath(report.id)} />
          </div>
        </>
      )}
      itemRowHeaderContentClassName="gap-8"
      itemRowHeaderControls={(
        (editable || deletable) && <TaskReportMenu report={report} />
      )}
    />
  )
}

TaskReportRow.propTypes = {
  report: types.objectOf(types.any).isRequired,
}

export default TaskReportRow
